import { useWebSocketContext } from '../contexts/WebSocketContext';

/**
 * Clock Controls Hook for Authenticated Operators
 */
export const useClockControls = (matchId) => {
  const { socket, connected } = useWebSocketContext();

  const startClock = () => {
    console.log('🚀 startClock called - matchId:', matchId, 'connected:', connected, 'socket:', !!socket);
    if (!socket || !connected) {
      console.warn('⚠️ Cannot start clock - socket or connection missing');
      return;
    }
    console.log('✅ Emitting match:clock:start', { matchId });
    socket.emit('match:clock:start', { matchId });
  };

  const stopClock = () => {
    if (!socket || !connected) return;
    socket.emit('match:clock:stop', { matchId });
  };

  const resetClock = (half = 1) => {
    if (!socket || !connected) return;
    socket.emit('match:clock:reset', { matchId, half });
  };

  const setTime = (minute, second) => {
    if (!socket || !connected) return;
    socket.emit('match:clock:set', { matchId, minute, second });
  };

  const setInjuryTime = (minutes) => {
    if (!socket || !connected) return;
    socket.emit('match:clock:injury', { matchId, minutes });
  };

  const changeHalf = (half) => {
    if (!socket || !connected) return;
    socket.emit('match:clock:half', { matchId, half });
  };

  return {
    connected,
    startClock,
    stopClock,
    resetClock,
    setTime,
    setInjuryTime,
    changeHalf
  };
};
